"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsEN = useIsEN;
exports.useIsJP = useIsJP;
exports.ueseIsHK = ueseIsHK;
const { useLang } = require('@fegobull/webapi').use;
const LANG = {
    EN: 2,
    CN: 0,
    JP: 5,
    HK: 1,
};
function useIsEN() {
    const { lang } = useLang();
    console.log('lang', lang);
    return lang === LANG.EN;
}
function useIsJP() {
    const { lang } = useLang();
    return lang === LANG.JP;
}
function ueseIsHK() {
    const { lang } = useLang();
    return lang === LANG.HK;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQVNBLDBCQUtDO0FBRUQsMEJBR0M7QUFFRCw0QkFHQztBQXhCRCxNQUFNLEVBQUUsT0FBTyxFQUFFLEdBQUcsT0FBTyxDQUFDLGtCQUFrQixDQUFDLENBQUMsR0FBRyxDQUFDO0FBRXBELE1BQU0sSUFBSSxHQUFHO0lBQ1QsRUFBRSxFQUFFLENBQUM7SUFDTCxFQUFFLEVBQUUsQ0FBQztJQUNMLEVBQUUsRUFBRSxDQUFDO0lBQ0wsRUFBRSxFQUFFLENBQUM7Q0FDUixDQUFDO0FBRUYsU0FBZ0IsT0FBTztJQUNuQixNQUFNLEVBQUUsSUFBSSxFQUFFLEdBQUcsT0FBTyxFQUFFLENBQUM7SUFDM0IsT0FBTyxDQUFDLEdBQUcsQ0FBQyxNQUFNLEVBQUUsSUFBSSxDQUFDLENBQUM7SUFFMUIsT0FBTyxJQUFJLEtBQUssSUFBSSxDQUFDLEVBQUUsQ0FBQztBQUM1QixDQUFDO0FBRUQsU0FBZ0IsT0FBTztJQUNuQixNQUFNLEVBQUUsSUFBSSxFQUFFLEdBQUcsT0FBTyxFQUFFLENBQUM7SUFDM0IsT0FBTyxJQUFJLEtBQUssSUFBSSxDQUFDLEVBQUUsQ0FBQztBQUM1QixDQUFDO0FBRUQsU0FBZ0IsUUFBUTtJQUNwQixNQUFNLEVBQUUsSUFBSSxFQUFFLEdBQUcsT0FBTyxFQUFFLENBQUM7SUFDM0IsT0FBTyxJQUFJLEtBQUssSUFBSSxDQUFDLEVBQUUsQ0FBQztBQUM1QixDQUFDIn0=